__webpack_require__.p = "https://js.skyscnr.com/sttc/banana/";